<app-paged-table [isCustomTable]="true" mode="base">
  <ng-container pre-table>
    <p class="t4 text-uppercase fw-medium">
      {{ 'Product group:' | trans:'cards/products-table/product-group.Label' }}
    </p>

    <div class="d-flex align-items-center gap-16 m-t-8 flex-wrap">
      @for (pg of productGroups(); track pg.id) {
        <app-chip
          [value]="pg.id"
          [selected]="selectedProductGroupIds.has(pg.id)"
          [disabled]="false"
          [label]="pg.name"
          (onClick)="selectedProductGroupIds.has(pg.id) ? selectedProductGroupIds.size > 1 ? selectedProductGroupIds.delete(pg.id) : null : selectedProductGroupIds.set(pg.id, pg.id); loadData(true);"
        />
      }
    </div>
  </ng-container>

  <ng-container table>
    <div class="d-flex gap-24 m-t-16 align-items-start">
      <div class="flex-grow-1 w-0">
        <ng-container
          [ngTemplateOutlet]="productsTableTemplate"
          [ngTemplateOutletContext]="{ dataContent: data ? (data | arraySlice:0:5) : [] }"
        />
      </div>

      <div class="flex-grow-1 w-0">
        <ng-container
          [ngTemplateOutlet]="productsTableTemplate"
          [ngTemplateOutletContext]="{ dataContent: data ? (data | arraySlice:5:10) : [] }"
        />
      </div>
    </div>
  </ng-container>
</app-paged-table>

<ng-template #productsTableTemplate let-dataContent="dataContent">
  @if (dataContent.length > 0) {
    <table class="base full-width">
      <thead>
      <tr>
        <th>
          {{ 'Product group' | trans:'cards/products-table/productGroup.Label' }}
        </th>
        <th class="text-right">
          {{ 'Product' | trans:'cards/products-table/product.Label' }}
        </th>
      </tr>
      </thead>
      <tbody>
        @for (p of dataContent; track  p.productId) {
          <tr
            class="selectable-tr cursor-pointer"
            [class.selected]="selectedProductIds.has(p.productId)"
            (click)="selectedProductIds.has(p.productId) ? selectedProductIds.delete(p.productId) : selectedProductIds.set(p.productId, p.productId); selectedProductIdsChanged.emit(selectedProductIds);"
          >
            <td>
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ p.productGroupName }}
              </div>
            </td>
            <td class="text-right">
              <div class="white-space-nowrap overflow-hidden text-overflow-ellipsis">
                {{ p.productName }}
              </div>
            </td>
          </tr>
        }
      </tbody>
    </table>
  }
</ng-template>
